const entityColor = {
  admin: 'red',
  athlete: 'teal',
  home: 'blue',
  exercise: 'orange',
  workout: 'cyan',
  achievement: 'yellow',
};

export default entityColor;
